module.exports = __webpack_public_path__ + "static/img/sensorypen.e37240a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pages/story-walk/sensorypen.jpg
// module id = 699
// module chunks = 0